import React from 'react'
import scrollIcon from "../assets/scroll.svg"
import { motion } from 'framer-motion'
import contactIcon from "../assets/contactDark.svg"


const Data = () => {
  return (
    <div className='home__data'>
        <div className='home__watchtower'>
          
          <motion.h1 
            className="home__title"
            initial={{
              x: 50,
              opacity: 0
            }}
            animate={{
              x:0,
              opacity: 1
            }}
            transition={{
              duration: 1,
              delay: 0.5
            }}
            viewport={{
              once: true,
            }}
          >
            Dr. Sasha Chaddah, MD
          </motion.h1>
          
          <motion.h3 
            className="home__subtitle"
            initial={{
              x: 50,
              opacity: 0
            }}
            animate={{
              x: 0,
              opacity: 1
            }}
            transition={{
              duration: 1,
              delay: 1
            }}
            viewport={{
              once: true,
            }}
          >
            Aesthetic Medicine
          </motion.h3>
        </div>
        <div className='home__bottomfeader' >
          <motion.p 
            className="home__description"
            initial={{
              opacity: 0,
              x: 50,
            }}
            animate={{
              opacity: 1,
              x: 0
            }}
            transition={{
              duration: 1,
              delay: 1.2
            }}
            viewport={{
              once: true,
            }}
          >
            Facial Balance & Harmony
          </motion.p>
        </div>        
       
    </div>
  )
}

export default Data
